export default {
  REQUEST: ":request@",
  RESPONSE: ":response@",
};
